export type Language = Zeta.ValueOf<typeof Languages>;
export type AppStatusCode = Zeta.ValueOf<typeof AppStatusCodes>;
export type ActionType = Zeta.ValueOf<typeof ActionTypes>;
export type SettingCategory = Zeta.ValueOf<typeof SettingCategories>;
export type LinkCategory = Zeta.ValueOf<typeof LinkCategories>;
export type EServiceType = Zeta.ValueOf<typeof EServiceTypes>;
export type UsefulLinkType = Zeta.ValueOf<typeof UsefulLinkTypes>;
export type UserNotificationType = Zeta.ValueOf<typeof UserNotificationTypes>;
export type CampaignCategory = Zeta.ValueOf<typeof CampaignCategories>;
export type CampaignResultFilterType = Zeta.ValueOf<typeof DownlineAgentFilterTypes>;
export type DownlineAgentFilterType = Zeta.ValueOf<typeof DownlineAgentFilterTypes>;
export type PerformanceResultType = Zeta.ValueOf<typeof PerformanceResultTypes>;
export type SearchType = Zeta.ValueOf<typeof SearchTypes>;
export type ResetPasswordType = Zeta.ValueOf<typeof ResetPasswordTypes>;
export type OTPMode = Zeta.ValueOf<typeof OTPModes>;
export type CommonBlockingType = Zeta.ValueOf<typeof CommonBlockingTypes>;
export type ReminderID = Zeta.ValueOf<typeof ReminderIDs>;
export type MyCustomerReportType = Zeta.ValueOf<typeof MyCustomerReportTypes>;
export type PremiumPayingRatioReportLevel = Zeta.ValueOf<typeof PremiumPayingRatioReportLevels>;

export enum PasswordStatus {
    none = '',
    expireSoon = 1,
    expired
}

export const ErrorCode = {
    apiError: 'eac/api-error',
    apiExceededLimit: 'eac/api-exceeded-limit',
    unauthorized: 'eac/unauthorized',
    invalidInput: 'eac/invalid-input',
    sessionExpired: 'eac/session-expired',
    fetchWhatsNewError: 'eac/fetch-news-error',
    fetchUserNotificationError: 'eac/fetch-notification-error',
    resetPasswordMissingID: 'eac/reset-password-missing-id',
    resetPasswordMissingDOB: 'eac/reset-password-missing-dob',
    resetPasswordFailed: 'eac/reset-password-failed',
    resetPasswordMaxRetry: 'eac/reset-password-max-retry',
    resetPasswordInvalidPassword: 'eac/reset-password-invalid-password',
    resetPasswordAccountIssue: 'eac/reset-password-account-issue',
    resetPasswordAccountTerminated: 'eac/reset-password-account-terminated',
    resetPasswordInvalidOTP: 'eac/reset-password-invalid-otp',
    resetPasswordInvalidID: 'eac/reset-password-invalid-id',
    resetPasswordInvalidDOB: 'eac/reset-password-invalid-dob',
    userPreferenceError: 'eac/user-preference-error',
    changePasswordReusedPassword: 'eac/change-password-reused-password',
    changePasswordOldPasswordIncorrect: 'eac/change-password-old-password-incorrect',
    changePasswordWithinSevenDays: 'eac/change-password-widthin-seven-days',
    changePasswordChangeEveryThreeMonth: 'eac/change-password-every-three-month',
    changePasswordDictWord: 'eac/change-password-dict-word',
    foreverLoveError: 'eac/forever-love-error',
    blockingAlreadyPassed: 'eac/blocking-already-passed',
    noAttentions: 'eac/no-attentions',
    fileNotAvailable: 'eac/file-not-available'
} as const;

export const Languages = {
    en: 'en',
    zhHK: 'zh-hk',
} as const;

export const AppStatusCodes = {
    available: 'G',
    limited: 'Y',
    critical: 'R',
} as const;

export const ActionTypes = {
    view: 'view',
    followUp: 'followUp',
} as const;

export const SettingCategories = {
    personal: 'personal',
    security: 'security',
    hardware: 'hardware-software',
} as const;

export const LinkCategories = {
    eService: 'eservice',
    report: 'reportlink',
    forms: 'forms',
    department: 'department',
    software: 'software',
    usefulLinks: 'useful-links',
} as const;

export const EServiceTypes = {
    customer: 'customer-related',
    agent: 'agent-personal',
    tools: 'tools',
    leader: 'leader-only',
} as const;

export const UsefulLinkTypes = {
    manuals: 'manuals',
    bulletin: 'bulletin',
    others: 'others',
} as const;

export const CampaignCategories = {
    agency: 'A',
    customerPromotion: 'O',
    customerSales: 'S',
    customerInfo: 'C',
    corporateSales: 'P',
    others: 'H',
} as const;

export const DownlineAgentFilterTypes = {
    district: 'district',
    unit: 'unit',
    agency: 'agency',
    agent: 'agent'
} as const;

export const PerformanceResultTypes = {
    my: 'my',
    team: 'team',
} as const;

export const UserNotificationTypes = {
    mcp: 'mcp',
    other: 'other',
    reminder: 'reminder',
} as const;

export const SearchTypes = {
    website: 'website',
    customer: 'customer',
    documents: 'ekms',
    products: 'plib',
} as const;

export const ResetPasswordTypes = {
    web: 'webapp',
    vrs: 'easytouch',
} as const;

export const OTPModes = {
    email: 'email',
    sms: 'sms',
} as const;

export const CommonBlockingTypes = {
    agentEmail: 'email-sign',
    covid19: 'vaccination',
    eExerciseBTDD: 'e-Exercise-BTDD',
    eExerciseMCV: 'e-Exercise-MCV',
    eExerciseMPF: 'e-Exercise-MPF',
    iengage: 'iEngage',
    mpf: 'mpf',
    scode: 'scode',
} as const;

export const ReminderIDs = {
    careerRepresentativeContracts: 'career-representative-contracts',
    iaLicenseRenewal: 'ia-license-renewal',
    blueCrossLicenseRequest: 'blue-cross-license-request',
} as const;

export const MyCustomerReportTypes = {
    all: 'A',
    customerView: 'C',
    vitality: 'Vi',
    aiaConnect: 'AC',
} as const;

export const PremiumPayingRatioReportLevels = {
    district: 'DT',
    agency: 'AY',
    agent: 'AG',
} as const;

export function keyof<T>(dict: T, value: Zeta.ValueOf<T>): undefined | keyof T {
    for (let i in dict) {
        if (dict[i] === value) {
            return i;
        }
    }
}
